// context/MobileMenuManager.js
import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';

const MobileMenuContext = createContext();

export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (!context) {
    throw new Error('useMobileMenu must be used within MobileMenuProvider');
  }
  return context;
};

export const MobileMenuProvider = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showDashboardSection, setShowDashboardSection] = useState(false);

  // أغلق القائمة عند تغيير المسار
  useEffect(() => {
    const handleRouteChange = () => {
      setMobileMenuOpen(false);
      setShowDashboardSection(false);
    };
    
    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  const openMobileMenu = useCallback(() => {
    setMobileMenuOpen(true);
  }, []);

  const closeMobileMenu = useCallback(() => {
    setMobileMenuOpen(false);
    setShowDashboardSection(false);
  }, []);

  const toggleMobileMenu = useCallback(() => {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  }, [mobileMenuOpen, closeMobileMenu, openMobileMenu]);

  const toggleDashboardSection = useCallback(() => {
    setShowDashboardSection(prev => !prev);
  }, []);

  return (
    <MobileMenuContext.Provider
      value={{
        mobileMenuOpen,
        showDashboardSection,
        openMobileMenu,
        closeMobileMenu,
        toggleMobileMenu,
        toggleDashboardSection,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  );
};